export default __webpack_public_path__ + "static/media/quad-logo.7cabb406.svg";